import { render, staticRenderFns } from "./PhoneChip.vue?vue&type=template&id=7390bf2e"
import script from "./PhoneChip.vue?vue&type=script&lang=js"
export * from "./PhoneChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports